import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS } from 'src/constants'

interface IProps {
  withoutIcon?: boolean
}

export const useStyles = makeStyles((theme: Theme) => ({
  formButton: ({ withoutIcon }: IProps) => ({
    '&&': {
      justifyContent: withoutIcon ? 'center' : 'flex-start',

      borderRadius: withoutIcon ? '1.6rem' : 10,
      backgroundColor: theme.palette.custom.primary,

      textTransform: withoutIcon ? 'none' : 'uppercase',
      fontSize: FONTS.SIZES.s,
      fontWeight: FONTS.WEIGHTS.bold,

      '& path': {
        fill: theme.palette.custom.white,
      },

      '&:disabled': {
        backgroundColor: theme.palette.custom.grey,

        '& path': {
          fill: theme.palette.custom.grey2,
        },
      },

      [theme.breakpoints.down('tablet')]: {
        minWidth: 150,
        height: 40,
      },
      [theme.breakpoints.up('tablet')]: {
        marginTop: 10,

        minWidth: 146,
        height: 50,
      },
    },
  }),
}))
